import React from 'react';
import clsx from 'clsx';
import { FormControlLabel as MuiFormControlLabel, FormControlLabelProps } from '@material-ui/core';

import useStyles from './FormControlLabel.style';

export const FormControlLabel: React.FC<FormControlLabelProps & { classNameLabel?: string }> = ({ className, classNameLabel, ...props }) => {
  const c = useStyles({});
  return <MuiFormControlLabel
          {...props}
          control={props.control}
          label={props.label}
          classes={{
            root: clsx(className, c.root),
            label: clsx(classNameLabel, c.label)
          }}
        />;
};
